// 'use strict'
// import http from '@/utils/http'
// validEmail
// import { validMobile } from '@/utils/validation'
import jsonBase from '@/service/request/jsonBase'
import myRequest from '../request/indexBase'
// 根据手机号发送验证码
export function getCode(data) {
  return myRequest.post({
    url: '/h3c/sso/getPhoneCode',
    data
  })
}

// 鉴权二注册接口
export function authTwo(data) {
  return myRequest.post({
    url: '/h3c/authUser/authTwo',
    data
  })
}
// 英文登录
export function loginEN(data) {
  return myRequest.post({
    url: '/h3c/authUser/loginEnglish',
    data
  })
}
// 鉴权一获取图形验证码
export function getCaptchaApi(params) {
  return myRequest
    .get({
      url: '/h3c/validateCode/captcha',
      params,
      responseType: 'arraybuffer'
    })
    .then((data) => {
      return `data:image/png;base64,${btoa(String.fromCharCode(...new Uint8Array(data)))}`
    })
}

// 解密
export function aesDecryptHex(data) {
  return myRequest.post({
    url: '/h3c/aes/aesDecryptHex',
    data
  })
}
// 加密
export function aesEncrypt(data) {
  return myRequest.post({
    url: '/h3c/aes/aesEncrypt',
    data
  })
}

// 单独预约接口
export function schedule(data) {
  return myRequest.post({
    url: '/h3c/schedule-c',
    data
  })
}

// 查询预约接口
export function getMakeStatus(params) {
  return myRequest.get({
    url: '/h3c/schedule-c/getMakeStatus',
    params
  })
}
// 根据cookie保存用户数据
export function saveByCookie(data) {
  return myRequest.post({ url: '/h3c/authUser/addUserByCookie', data })
}
// 查询嘉宾json文件
export function guestChinese() {
  return jsonBase.get({
    url: 'guestEnglish.json'
  })
}
// 查询用户已预约日程
export function getMakeScheduleList(params) {
  return myRequest.get({
    url: '/h3c/schedule-c/getMakeScheduleList',
    params
  })
}
// 查询首页伙伴json文件
export function partnerHome() {
  return jsonBase.get({
    url: 'partnerHome.json'
  })
}
// 查询个人信息接口
export function desensitization(data) {
  return myRequest.post({
    url: '/h3c/authUser/desensitization',
    data
  })
}
// 问卷联调
export function saveQuestionAnswers(data) {
  return myRequest.post({
    url: '/h3c/question-record/saveQuestionAnswers',
    data
  })
}
export function liveDownloadRecord(data) {
  return myRequest.post({
    url: '/h3c/live-download-record/liveDownloadRecord',
    data
  })
}
export function liveView(data) {
  return myRequest.post({
    url: '/h3c/userLiveLogs',
    data
  })
}
// 新闻资讯列表json文件 newsChinese newsEnglish
export function newsList() {
  return jsonBase.get({
    url: 'newsEnglish.json'
  })
}
